import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid'
import moment from 'moment'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const VragenlijstenResumer = ({timeline, user, vragenlijst}) => {

  const detail = {
    address_full: user?.userdetails_address_full,
    avatar : user?.userdetails_avatar,
    cellphone_number: user?.userdetails_cellphone_number,
    city: user?.userdetails_city,
    country:user?.userdetails_country,
    country_code :user?.userdetails_country_code,
    date_of_birth : user?.userdetails_date_of_birth,
    email: user?.userdetails_email,
    first_name :user?.userdetails_first_name,
    last_name :user?.userdetails_last_name,
    full_name: user?.userdetails_full_name,
    housenr: user?.userdetails_housenr,
    id :user?.userdetails_id,
    klacht : user?.userdetails_klacht,
    more_details : user?.userdetails_more_details,
    phone_number : user?.userdetails_phone_number,
    role_id : user?.userdetails_role_id,
    street : user?.userdetails_street,
    user_id: user?.userdetails_user_id,
    verstuur_klacht_date: user?.vragenlijsten_verstuur_klacht_date,
    verstuur_preintake_date: user?.vragenlijsten_verstuur_preintake_date,
    verstuur_voeding_date: user?.vragenlijsten_verstuur_voeding_date
  }

  const navigate = useNavigate();
  const completedCount =
    Number(vragenlijst?.preintake_verstuur === 1) +
    Number(vragenlijst?.klacht_verstuur === 1) +
    Number(vragenlijst?.voeding_verstuur === 1);
  const totalCount = timeline?.length || 0;
  const completionPct = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;


  const goToUser = () => {
    navigate("/healthforms", { state: detail});
  };

  return (
    <section aria-labelledby="timeline-title" className="min-w-0 lg:col-span-1 lg:col-start-3">
    <div className="rounded-2xl border border-wa-border bg-wa-panel px-4 py-5 shadow-[0_22px_55px_-36px_rgba(0,0,0,0.55)] ring-1 ring-black/[0.04] dark:ring-white/[0.06] sm:px-6">
      <div className="mb-4 rounded-xl border border-wa-border/80 bg-wa-panel2/60 p-4 ring-1 ring-inset ring-black/[0.03] dark:bg-wa-panel2/40 dark:ring-white/[0.04]">
        <h2 id="timeline-title" className="text-center text-lg font-bold tracking-tight text-wa-text">
          Vragenlijsten
        </h2>
        <p className="mt-1 text-center text-xs font-medium text-wa-muted">
          {completedCount} van {totalCount} afgerond
        </p>
        <div className="mt-3 h-2 overflow-hidden rounded-full bg-wa-hover ring-1 ring-inset ring-wa-border/40">
          <div
            className="h-full rounded-full bg-gradient-to-r from-wa-accentdeep to-wa-accent transition-all duration-500"
            style={{ width: `${completionPct}%` }}
          />
        </div>
      </div>

      {/* Activity Feed */}
      <div className="mt-6 flow-root">
        <ul role="list" className="-mb-8">
          {timeline.map((item, itemIdx) => {
             
             let pr = (vragenlijst?.preintake_verstuur == 1 && item.id == 1);  
              let kl = (vragenlijst?.klacht_verstuur == 1 && item.id == 2);
              let voed = (vragenlijst?.voeding_verstuur == 1 && item.id == 3);

              let v_klacht_date = vragenlijst?.verstuur_klacht_date;
              let v_preintake_date = vragenlijst?.verstuur_preintake_date;
              let v_voeding_date = vragenlijst?.verstuur_voeding_date;
              const itemDate =
                item.id === 1 ? v_preintake_date : item.id === 2 ? v_klacht_date : v_voeding_date;
            
            return (
            <li key={item.id}>
              <div className="relative pb-8">
                {itemIdx !== timeline.length - 1 ? (
                  <span
                    aria-hidden="true"
                    className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-wa-border"
                  />
                ) : null}
                <div className="relative flex gap-3 rounded-xl border border-wa-border/80 bg-wa-panel2/50 p-3.5 shadow-sm ring-1 ring-black/[0.03] dark:bg-wa-panel/35 dark:ring-white/[0.05]">
                  <div className="shrink-0 pt-0.5">
                    <span
                      className={classNames(
                        "flex h-10 w-10 items-center justify-center rounded-xl ring-2 ring-offset-2 ring-offset-wa-panel2 dark:ring-offset-wa-panel",
                        (pr || kl || voed)
                          ? "bg-wa-accent text-wa-onaccent ring-wa-accent/40"
                          : "bg-red-600 text-white ring-red-500/35"
                      )}
                    >
                      {(pr || kl || voed) ? (
                        <CheckIcon aria-hidden="true" className="h-5 w-5" />
                      ) : (
                        <XMarkIcon aria-hidden="true" className="h-5 w-5" />
                      )}
                    </span>
                  </div>
                  <div className="flex min-w-0 flex-1 justify-between gap-3 pt-0.5">
                    <div className="min-w-0">
                      <p className="text-sm font-semibold leading-snug text-wa-text">{item.content} </p>
                      <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1">
                        <span className="text-[10px] font-bold uppercase tracking-wide text-wa-muted">
                          Status
                        </span>
                        <span
                          className={classNames(
                            "text-xs font-semibold",
                            (pr || kl || voed)
                              ? "text-emerald-600 dark:text-emerald-400"
                              : "text-red-500 dark:text-red-400"
                          )}
                        >
                          {(pr || kl || voed) ? "Verstuurd" : "Niet verstuurd"}
                        </span>
                      </div>
                    </div>
                    <div className="shrink-0 whitespace-nowrap pt-0.5 text-right text-[11px] font-medium text-wa-muted">
                      <time dateTime={item.datetime}>
                        {itemDate ? moment(itemDate).format("DD/MM/YYYY") : "—"}
                      </time>
                    </div>
                  </div>
                </div>
              </div>
            </li>
)})}
        </ul>
      </div>
      <div className="mt-6 flex flex-col justify-stretch">
        <button
          onClick={goToUser}
          type="button"
          className="inline-flex w-full items-center justify-center rounded-xl bg-wa-accent px-4 py-2.5 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
        >
          Ga naar vragenlijsten
        </button>
      </div>
    </div>
  </section>  )
}

export default VragenlijstenResumer